import React from 'react';
import './ResidentHomeLoader.css';

interface ResidentHomeLoaderProps {
  caption?: string;
}

const ResidentHomeLoader: React.FC<ResidentHomeLoaderProps> = ({
  caption = 'Loading your home…',
}) => (
  <div className="resident-home-loader" role="status" aria-live="polite" aria-busy="true">
    <div className="resident-home-loader-t" aria-hidden="true">
      <span className="resident-home-loader-t-base">T</span>
      <div className="resident-home-loader-t-fill-wrap">
        <span className="resident-home-loader-t-fill">T</span>
      </div>
    </div>
    <p className="resident-home-loader-caption">{caption}</p>
  </div>
);

export default ResidentHomeLoader;
